import { useEffect } from 'react';
import { Row, Col } from 'Common';
import { Switch } from 'react-router-dom';
import { SubscriptionStatusPage, UserAttendanceStatusPage } from 'Page';
import balloonProfile1x from 'images/profile/balloon_with_clouds.png';
import balloonProfile2x from 'images/profile/balloon_with_clouds@2x.png';
import balloonProfile3x from 'images/profile/balloon_with_clouds@3x.png';
import { linkHandler } from 'utils/linkHandler';
import {
  FlashListContainer,
  InvoicesContainer,
  PrivateRouteContainer,
  VoucherRouteContainer,
  GiftCouponRetrieverContainer
} from 'containers';
import { PersonalData, Help, SpecialFeature, SubscriptionAlerts, CodeEntry } from 'components';
import { ProfileNavigation } from './ProfileNavigation';
import { MainPage } from 'Container';
import PaymentOptions from '../PaymentOptions';
import { useDispatch } from 'react-redux';
import { getUserPaymentInfosRequest } from 'redux/actions';

export const PROFILE_ROUTES = {
  invoices: '/profile/invoices',
  paymentOptions: '/profile/payment-options',
  personalData: '/profile/personal-data',
  subscriptionStatus: '/profile/subscription-status',
  attendances: '/profile/attendances-status',
  help: '/profile/help',
  specialFeature: '/profile/special-feature',
  voucher: '/gutschein',
  voucherManuel: '/gutschein/anleitung'
};

export const Profile = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserPaymentInfosRequest({ renewable: true }));
  }, []);

  return (
    <MainPage bodyClassName="main-decorated" className="profile">
      <Row>
        <FlashListContainer />
        <SubscriptionAlerts />
      </Row>
      <Row>
        <Col>
          <div className="card-profile">
            <Row>
              <Col className="col-12 col-sm-12 col-md-4 px-sm-0">
                <ProfileNavigation profileRoutes={PROFILE_ROUTES} />
              </Col>
              <Col className="col-12 col-sm-12 col-md-8 px-sm-0">
                <div className="profile-content">
                  <Switch>
                    <PrivateRouteContainer path={linkHandler.get('deeplinkConfirmMail')} component={CodeEntry} />
                    <PrivateRouteContainer path={PROFILE_ROUTES.personalData} component={PersonalData} />
                    <VoucherRouteContainer path={PROFILE_ROUTES.subscriptionStatus} component={SubscriptionStatusPage} />
                    <VoucherRouteContainer path={PROFILE_ROUTES.attendances} component={UserAttendanceStatusPage} />
                    <PrivateRouteContainer path={PROFILE_ROUTES.invoices} component={InvoicesContainer} />
                    <PrivateRouteContainer path={PROFILE_ROUTES.paymentOptions} component={PaymentOptions} />
                    <PrivateRouteContainer path={PROFILE_ROUTES.help} component={Help} />
                    <PrivateRouteContainer path={PROFILE_ROUTES.specialFeature} component={SpecialFeature} />
                    <VoucherRouteContainer path={PROFILE_ROUTES.voucher} component={GiftCouponRetrieverContainer} />
                  </Switch>
                </div>
              </Col>
            </Row>
            <img
              className="profile__balloon"
              srcSet={`${balloonProfile1x} 165w, ${balloonProfile2x} 330w, ${balloonProfile3x} 495w`}
              src={balloonProfile1x}
              alt="Balloon über den Wolken"
            />
          </div>
        </Col>
      </Row>
    </MainPage>
  );
};

export default Profile;
